import { render, staticRenderFns } from "./importExcelUser.vue?vue&type=template&id=ddba6046&scoped=true"
import script from "./importExcelUser.vue?vue&type=script&lang=js"
export * from "./importExcelUser.vue?vue&type=script&lang=js"
import style0 from "./importExcelUser.vue?vue&type=style&index=0&id=ddba6046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddba6046",
  null
  
)

export default component.exports